import { useKeydown } from "@tosize/ui";
import { useCallback } from "react";
import { AppModus, CompartmentModus, LayoutModus, useCanvasStore } from "./useCanvasStore";

export function useNavigation() {
	const {
		appMode,
		setAppMode,
		setCompartmentMode,
		setLayoutMode,
		deselectAllCompartments,
		setAllCompartmentsOpen,
	} = useCanvasStore();

	const navigate = useCallback(
		(mode: AppModus | null) => {
			const inActive = mode !== appMode;

			setAppMode(inActive ? mode : null);

			if (!!mode && !!inActive) {
				deselectAllCompartments();

				setLayoutMode(inActive && mode === AppModus.layout ? LayoutModus.move : null);

				setCompartmentMode(
					inActive && mode === AppModus.compartment ? CompartmentModus.DoorLeft : null,
				);
			}

			setAllCompartmentsOpen(inActive && mode === AppModus.compartment);
		},
		[
			appMode,
			setAppMode,
			deselectAllCompartments,
			setLayoutMode,
			setCompartmentMode,
			setAllCompartmentsOpen,
		],
	);

	useKeydown(() => {
		deselectAllCompartments();
		setLayoutMode(null);
		setCompartmentMode(null);
		setAllCompartmentsOpen(false);
	});

	return { navigate };
}
